import React, { Fragment, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '../../components/container';
import Card from '../../components/table.card';

import './companies.scss';

import { ReactComponent as ButtonChecker } from './button-checker.svg';

import Button from '../../components/button';
import Table from '../../components/table';

import CompanyInfoPopUp from '../../popups/company.info';
import useGlobal from '../../../store';
import useReloadDummy from '../../../scripts/hooks/use.reload.dummy';
import MenuMobile from '../../components/menu-mobile';

const Companies = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { companiesList } = globalState;
  const { users, sign } = globalActions;

  const navigate = useNavigate();
  const [ Dummy, reloadDummy ] = useReloadDummy();

  const TABLE_SETTINGS = {

    head: [

      "ID",
      "Название компании",
      "Владелец",
      "Телефон",
      "E-mail",
      "Комментарий",
      "Добавлена"

    ],

    template: "3% 14% 25% 9% 11% 24% 14%"

  }

  const [ CompanyPopup, showCompanyPopup, hideCompanyPopup ] = CompanyInfoPopUp();

  useEffect(() => { users.all( reloadDummy ) }, [])

  return (

    <Fragment>

      { CompanyPopup }

      <Container className = "container__companies companies relative">

        <MenuMobile pages = { 1 } />

        <div className="companies__header flex">

          <div className="companies__header__headmobile flex">

            <p className="companies__head montserrat">Компании</p>
          
            <div className="companies__add-button__container relative">

              <Button
              
                text="Добавить"
                icon = { <ButtonChecker /> }
                className="companies__add-button__button"
                action={ showCompanyPopup }

              />

            </div>

          </div>

        </div>

        <Dummy />

        <Table
        
          className = "desktop"
          head = { TABLE_SETTINGS.head }
          rows = { companiesList }
          action = { id => navigate(`/companies/${ id }`) }
          templateColumns = { TABLE_SETTINGS.template }

        />

        <div className="companies__cardlist mobile">

          { companiesList.map(( el, key ) => (

            <Card 
            
              key = { key }
              city = { el.fio }
              email = { el.email }
              date = { el.reg_date }
              company = { el.company_name }
              created_at = { el.created_at }
              allnames = { el.fio }
              phone = { el.phone }
              action = { () => navigate(`/companies/${ el.id }`) }
            
            />

          ))}

          <div style = {{ height: '90px' }} />

          

          <div 
            onClick = { () => { 
              if ( !window.confirm('Вы точно хотите выйти?') ) return;
              sign.Out();
            }}
            style = {{ 
              
              textAlign: 'center',
              marginRight: '20px', color: 'red', cursor: 'pointer' 
            
            }}
          >
            выйти из панели администратора
          </div>

        </div>

      </Container>

    </Fragment>

  );

}

export default Companies;